'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type DomainTreeCollapsedState = {
  collapsedByRoute: Record<string, boolean>;
  _hasHydrated: boolean;

  setHasHydrated: (hasHydrated: boolean) => void;
  setIsCollapsed: (routeKey: string, isCollapsed: boolean) => void;
  getIsCollapsed: (routeKey: string) => boolean;
};

const STORAGE_KEY = 'terra-domain-tree-collapsed';

export const useDomainTreeCollapsedStore = create<DomainTreeCollapsedState>()(
  persist(
    (set, get) => ({
      collapsedByRoute: {},
      _hasHydrated: false,

      setHasHydrated: (hasHydrated: boolean) => {
        set({ _hasHydrated: hasHydrated });
      },

      setIsCollapsed: (routeKey: string, isCollapsed: boolean) => {
        set((state) => ({
          collapsedByRoute: {
            ...state.collapsedByRoute,
            [routeKey]: isCollapsed,
          },
        }));
      },

      getIsCollapsed: (routeKey: string) => {
        return get().collapsedByRoute[routeKey] ?? false;
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        collapsedByRoute: state.collapsedByRoute,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    },
  ),
);
